import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-services-one',
  templateUrl: './services-one.component.html',
  styleUrls: ['./services-one.component.scss']
})
export class ServicesOneComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
